// src/pages/admin/AdminAnnouncementEdit.js
import React, { useEffect, useState } from "react";
import {
  getAnnouncementById,
  updateAnnouncement,
  createAnnouncement,
} from "../../services/announcementService";
import { useNavigate, useParams } from "react-router-dom";
import "./AdminAnnouncementEdit.css";

function AdminAnnouncementEdit() {
  const { id } = useParams(); // ถ้าเป็น "new" แปลว่าสร้างใหม่
  const navigate = useNavigate();

  // route "announcements/new" has no :id param, so id is undefined there
  const isNew = !id || id === "new";

  const [form, setForm] = useState({
    title: "",
    description: "",
    category: "",
    fileUrl: "",
    status: "draft",
  });

  const [loading, setLoading] = useState(!isNew);
  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");

  // load the announcement whenever the :id in the URL changes (nothing to load for a new one); an answer that
  // arrives after the admin moved to another id is ignored
  useEffect(() => {
    if (isNew) return undefined;
    let current = true;
    (async () => {
      setLoading(true);
      setError("");
      let data;
      try {
        data = await getAnnouncementById(id);
      } catch (err) {
        if (current) {
          setError(`โหลดใบประกาศไม่สำเร็จ: ${err.message}`);
          setLoading(false);
        }
        return;
      }
      if (!current) return;
      if (!data) {
        alert("ไม่พบใบประกาศ");
        navigate("/admin/announcements");
        return;
      }
      setForm({
        title: data.title || "",
        description: data.description || "",
        category: data.category || "",
        fileUrl: data.fileUrl || "",
        status: data.status || "draft",
      });
      setLoading(false);
    })();
    return () => { current = false; };
  }, [id, isNew, navigate]);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      // the daily PDF and the edition read imageUrl — keep it on the same file as fileUrl
      const payload = form.fileUrl ? { ...form, imageUrl: form.fileUrl } : form;
      if (isNew) {
        await createAnnouncement(payload);
      } else {
        await updateAnnouncement(id, payload);
      }
      navigate("/admin/announcements");
    } catch (err) {
      setError(`บันทึกไม่สำเร็จ: ${err.message}`);
    } finally {
      setSaving(false);
    }
  }

  function handleCancel() {
    navigate("/admin/announcements");
  }

  if (loading) {
    return <div className="admin-ann-edit-container">กำลังโหลด...</div>;
  }

  return (
    <div className="admin-ann-edit-container">
      <h2>{isNew ? "ลงประกาศใหม่" : "แก้ไขใบประกาศ"}</h2>
      {error && <p className="adm-msg err">{error}</p>}

      <form className="admin-ann-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>หัวข้อประกาศ</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-row">
          <label>รายละเอียด</label>
          <textarea
            name="description"
            rows={4}
            value={form.description}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <label>ประเภท (หมวดหมู่)</label>
          <input
            type="text"
            name="category"
            value={form.category}
            onChange={handleChange}
            placeholder="เช่น ประกาศรับสมัครงาน, ประกาศทั่วไป"
          />
        </div>

        <div className="form-row">
          <label>ลิงก์ไฟล์ (PDF / รูปภาพ)</label>
          <input
            type="text"
            name="fileUrl"
            value={form.fileUrl}
            onChange={handleChange}
            placeholder="ใส่ URL ที่เก็บไฟล์ไว้"
          />
        </div>

        <div className="form-row">
          <label>สถานะ</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
          >
            <option value="draft">ร่าง (ยังไม่เผยแพร่)</option>
            <option value="published">เผยแพร่</option>
          </select>
        </div>

        <div className="form-actions">
          <button type="button" className="btn-ghost" onClick={handleCancel}>
            ยกเลิก
          </button>
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? "กำลังบันทึก..." : "บันทึก"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AdminAnnouncementEdit;
